import { type EventFilter } from "@package/ui-gql/index-analytics";
import { type WritableDraft } from "immer";
import { useItemGridFilterContext } from "../ItemGridFilter/context-item-grid-filter";
import { ItemGridFilterDateRange } from "../ItemGridFilter/ItemGridFilterDateRange";

type SupportedFilter = EventFilter | null | undefined;

export function ItemGridFilterDateTimeRange() {
  const { filter, updateFilterState } = useItemGridFilterContext();

  const filterWithDateTimeRange: SupportedFilter = filter;

  return (
    <ItemGridFilterDateRange
      start={filterWithDateTimeRange?.range?.start ?? null}
      end={filterWithDateTimeRange?.range?.end ?? null}
      property="range"
      text="Date Range"
      onRequestFilterReset={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            delete draft.range;
          }
        })
      }
      onRequestFilterUpdate={(start, end) =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            draft.range = {
              start: start ?? undefined,
              end: end ?? undefined,
            };
          }
        })
      }
    />
  );
}
